<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="540px">
      <v-card class="rounded-lg">
        <v-toolbar elevation="0" color="background">
          <v-toolbar-title class="pl-3 mt-2">
            <span class="skipTitle">{{
              $t('message.pages.welcomePanda.skipDialog.youShure')
            }}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="handleClose()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="pl-7 pr-5 py-0">
          <v-container class="pl-0">
            <v-row no-gutters>
              <span class="textCta">{{
                $t('message.pages.welcomePanda.skipDialog.youShureCta')
              }}</span>
            </v-row>
            <v-row no-gutters>
              <span class="textSub my-2">{{
                $t('message.pages.welcomePanda.skipDialog.youMatter')
              }}</span>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-8 pb-6 mt-4">
          <v-spacer></v-spacer>
          <base-btn
            type="tertiary"
            class="mr-2 px-10 rounded-lg elevation-0"
            @click="skipQuestion(true)"
          >
            {{ $t('message.pages.welcomePanda.actions.skip') }}
          </base-btn>
          <base-btn
            class="px-4 rounded-lg elevation-0"
            type="primary"
            @click="skipQuestion(false)"
          >
            {{ $t('message.pages.welcomePanda.actions.next') }}
          </base-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'SkipQuestionary',
  components: {},
  data: () => ({
    open: null,
  }),
  mounted() {
    this.$root.$on('skipQuestionary', () => {
      this.open = true
    })
  },
  beforeDestroy() {
    this.$root.$off('skipQuestionary')
  },
  methods: {
    skipQuestion(skipped = false) {
      this.$root.$emit('skippedQuestion', skipped)
      this.handleClose()
    },
    handleClose() {
      this.$root.$emit('renameModalClosed')
      this.open = null
    },
  },
}
</script>

<style scoped lang="scss">
.skipTitle {
  font-weight: 500;
  font-size: 18px;
  line-height: 21.6px;
}
.textCta {
  font-weight: 400;
  font-size: 18px;
  line-height: 21.6px;
  color: $neutral-30-base-light;
}
.textSub {
  font-weight: 400;
  font-size: 18px;
  line-height: 24.6px;
  color: $neutral-40-light-light;
}
.bg-dark {
  .textCta {
    font-weight: 400;
    color: $neutral-30-base-dark;
  }
  .textSub {
    font-weight: 400;
    color: $neutral-40-light-dark;
  }
}
</style>
